<content-panel #panel [itemsCount]="totalCount" [hidden]="docId"
               [loading]="currentRequest && !currentRequest.closed" >
  <ng-template contentPlaceholder>
    <div class="content-state">
      <img src="/assets/images/admin-docs-placeholder-icon.svg" alt="placeholder-icon" width="120" height="120">
      <div class="state-title">{{'search-placeholder.admin-docs.title' | translate}}</div>
      <div class="state-subtitle">
        <div><span class="fw-bold">
          {{nbTotalAdminDoc?.toLocaleString()}}</span> {{'search-placeholder.admin-docs.publications' | translate}}
        </div>
        <div><span class="fw-bold">
          {{nbTotalWebsite?.toLocaleString()}}</span> {{'search-placeholder.admin-docs.web-references' | translate}}
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template contentList [items]="entities" [headerTemplate]="headerTemplate" [itemTemplate]="itemTemplate">
  </ng-template>
  <ng-template contentFooter>
    @if (nbPages > 1) {
      <app-pagination [nbPages]="nbPages" [stats]="dataUpdated"></app-pagination>
    }
  </ng-template>
  <ng-template contentLoading>
    <div class="content-loading">
      <ex-overlay-loader direction="column" color="secondary" [text]="'search.loading' | translate"></ex-overlay-loader>
    </div>
  </ng-template>
  <ng-template contentEmpty>
    <div class="content-state">
      <mat-icon svgIcon="close-circle-fill"></mat-icon>
      <div class="state-title">{{'content.no-result-message' | translate}}</div>
      <div class="state-subtitle">
        {{'content.indicative-no-result-message' | translate}}
      </div>
    </div>
  </ng-template>
</content-panel>
<section [hidden]="!docId">
  <router-outlet></router-outlet>
</section>


<ng-template #headerTemplate>
  <div class="results-header">
    <div class="flex-1">
      <div class="results-title">
        {{ (totalCount == 10000 ? 'search.more-than' : "") | translate }}
        {{ totalCount?.toLocaleString() }}
        {{ (totalCount && totalCount > 1 ? 'search.results' : 'search.result') | translate }}
      </div>
      <div class="results-subtitle">
        {{ (adminDocsCount > 1 ? 'search.admin-doc-results' : 'search.admin-doc-result')
        | translate: {totalCount: adminDocsCount.toLocaleString()} }}
        {{ (websitesCount > 1 ? 'search.admin-doc-sub-results' : 'search.admin-doc-sub-result')
        | translate: {nbWebsite: websitesCount.toLocaleString()} }}
      </div>
    </div>
    <ex-button type="ai" variant="tonal" size="medium" class="align-items-center"
               (click)="smartSearchService.openSmartSearchModal()">
      <div class="d-flex align-items-center gap-1">
        <mat-icon svgIcon="sparks-filled" class="icon-20"></mat-icon>
        <span> {{ "search.smart-search-button" | translate }} </span>
      </div>
    </ex-button>
  </div>
</ng-template>
<ng-template #itemTemplate let-item>
  <app-admin-doc-card
    data-cy="admin-doc-card"
    [bookmarkPaths]="item['bookmark_paths']"
    [docId]="item.id"
    [title]="item.title"
    [publicationDate]="item.publication_date"
    [website]="item.website"
    [nbOccurrences]="item['occurrence_count']"
    [text]="item['excerpt'][0]"
    [url]="item['url']"
    [displayedPublicationType]="item.displayed_publication_type"
    [matchStems]="item.match_stems"
    [source]="item.source"
    [territories]="item.territories"
    [redirectsToUrl]="item['redirects_to_url']"
    [projectUid]="item.project_uid"
  />
</ng-template>
